export function buildDataRequestPayload(data) {
  return {
    requiredInformation: data.requiredInformation,
    employeer: data.employeer,
    purposeOfRequestingData: parseInt(data.purposeOfRequestingData),
    formOfDataRequested: parseInt(data.formOfDataRequested),
    isPublished: true,
    status: 3,
  };
}
